import { BaseApi } from './base.api.js';

import { ApiError } from '../errors/api-error.js';

export class RiskTreatmentApi extends BaseApi {
    constructor(client) {
        super(client, '/risk-treatment');
    }

    async getStats() {
        try {
            const response = await this.client.get(`${this.basePath}/stats`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getExecutionStats(queryParams = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/execution-stats`, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getExecutionTicket(id, queryParams = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/ticket`, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async openExecutionTicket(id, queryParams = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/open-ticket`, {}, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
